import clsx from 'clsx';
import { Radio as AriaRadio, type RadioProps as AriaRadioProps, composeRenderProps } from 'react-aria-components';

import { RadioCheckmark } from './RadioCheckmark';
import { Text } from '../typography';
import styles from './Radio.module.css';

export type Props = Pick<AriaRadioProps, 'slot' | 'value' | 'isDisabled' | 'children'> & {
  alignment?: 'top' | 'center';
};

export function Radio({ children: childrenWithRenderProps, alignment = 'center', ...props }: Props) {
  return (
    <AriaRadio className={clsx(styles.root, styles[`alignment-${alignment}`])} {...props}>
      {composeRenderProps(childrenWithRenderProps, (children, { isDisabled, ...restRenderProps }) => {
        return (
          <>
            <RadioCheckmark {...restRenderProps} isDisabled={isDisabled} />
            {children ? (
              <Text color={isDisabled ? 'gray-500' : 'gray-800'} asChild>
                <div>{children}</div>
              </Text>
            ) : null}
          </>
        );
      })}
    </AriaRadio>
  );
}
